import Event from '../../core/Event';
import { UserSessionDetails } from '../epic/CognitoUserAuthenticator';

export default class UserAuthenticationSucceed extends Event {
    public static type = 'UserAuthenticationSucceed';

    constructor(public readonly sessionDetails: UserSessionDetails) {
        super(UserAuthenticationSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserAuthenticationSucceed.ts